import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';

@Component({
  selector: 'wl-ecom-item-edit-search-keywords',
  templateUrl: './ecom-item-edit-search-keywords.component.html',
  styleUrls: ['./ecom-item-edit-search-keywords.component.less'],
    standalone: false
})
export class EComItemEditSearchKeywordsComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  keywords: Array<string> = [];
  newKeyword: string = '';
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem) {
      this.keywords = this.eCommerceItem.Keywords ? this.eCommerceItem.Keywords.split(' ') : [];
    }
  }

  addKeyword(event: Event) {
    event.preventDefault();
    if (this.newKeyword && this.newKeyword.trim()) {
      this.keywords.push(this.newKeyword.trim());
      this.newKeyword = '';
      this.keywordChanges();
    }
  }

  addKeywordOnBlur() {
    if (this.newKeyword && this.newKeyword.trim()) {
      this.keywords.push(this.newKeyword.trim());
      this.newKeyword = '';
      this.keywordChanges();
    }
  }

  removeKeyword(keyword: string) {
    const index = this.keywords.indexOf(keyword);
    if (index > -1) {
      this.keywords.splice(index, 1);
      this.keywordChanges();
    }
  }

  keywordChanges() {
    this.eCommerceItem.Keywords = this.keywords.join(' ');
  }
}
